import React from "react";
import { PuffLoader } from "react-spinners";
import { motion } from "framer-motion";

const fadeInVariants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1 },
};

const QuickbuyLoading = ({ loadingType, message, color = "#DD097D", service }) => {
	return (
		<motion.div
			className="flex flex-grow gap-6 flex-col w-full h-full justify-center items-center text-center"
			initial="hidden"
			animate="visible"
			variants={fadeInVariants}
			transition={{ duration: 0.5 }}
		>
			<PuffLoader color={color} size={48} />
			<div className="flex flex-col gap-4 items-center w-full text-base animate-pulse">
				<p>
					{message || (
						<>
							Fetching <span className="font-bold uppercase">{service}</span>{" "}
							{loadingType === "locations"
								? " locations "
								: loadingType === "plans"
								? " plan resources"
								: loadingType === "resources"
								? " resources"
								: "data"}
						</>
					)}
				</p>
			</div>
		</motion.div>
	);
};

export default QuickbuyLoading;
